import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import appReducer from './ducks';

import { Types } from './ducks/user';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middlewares = [ReduxThunk];

/**
 *
 * @param {STORE_DEFINITION} state
 * @param {*} action
 */
const rootReducer = (state, action) => {
  /** @type {STORE_DEFINITION} */
  const clearedState =
    action.type === Types.LOGOUT
      ? appReducer(undefined, action)
      : appReducer(state, action);
  const isUpdateAvailable =
    action.type === Types.LOGOUT && state && state.syncs
      ? state.syncs.updateAvailable // Maintain previous update flag
      : clearedState.syncs.updateAvailable; // Mantain the current
  return {
    ...clearedState,
    syncs: {
      ...clearedState.syncs,
      // Mantain the update available flag from the previous version
      updateAvailable: isUpdateAvailable,
    },
  };
};

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares)),
);

export default store;
